import { useState } from 'react';

import { AccessibilityPreferencesLauncher } from './AccessibilityPreferencesLauncher';
import { AccessibilityPreferencesPanel } from './AccessibilityPreferencesPanel';

interface AccessibilityPreferencesWidgetProps {
  enabled: boolean;
}

// Just the launcher + its panel's open/closed state — the preferences
// themselves live in context (see accessibility-preferences-context.tsx),
// provided higher up in PublicSite.tsx alongside the effective theme, so
// this widget can be gated on/off per-site without affecting whether
// preferences are readable elsewhere on the page.
export function AccessibilityPreferencesWidget({ enabled }: AccessibilityPreferencesWidgetProps) {
  const [open, setOpen] = useState(false);

  if (!enabled) return null;

  return (
    <>
      <AccessibilityPreferencesLauncher onClick={() => setOpen(true)} />
      <AccessibilityPreferencesPanel open={open} onClose={() => setOpen(false)} />
    </>
  );
}
